cbp-carousel-item {
  display: inline-block;
  height: var(--cbp-carousel-item-height);
  width: var(--cbp-carousel-item-width);
  flex-shrink: 0;

  &>* {
    height: inherit;
    width: inherit;
  }
}